import api from "api";

// Fetching Attendance Page data
export const getAttandance = ({ month, year, team, reportingManagerIdsArray, pageNumber, pageSize, house }) => {
  const filterAndTransformParams = (params) => {
    return Object.fromEntries(
      Object.entries(params)
        .filter(([key, value]) =>
          Array.isArray(value) ? value.length > 0 : Boolean(value)
        )
        .map(([key, value]) => [
          key,
          Array.isArray(value) ? JSON.stringify(value) : value,
        ])
    );
  };
  const reportingManagerIds = Array.isArray(reportingManagerIdsArray) 
  ? reportingManagerIdsArray.map(id => String(id)) 
  : [];

const params = {
  reportingManagerIdsArray: reportingManagerIds,
  team,
  month,
  year,
  pageNumber,
  pageSize,
  house
};

const transformedParams = filterAndTransformParams(params);
const urlParams = new URLSearchParams(transformedParams);
const queryString = urlParams.toString();
const url = `attendance${queryString ? `?${queryString}` : ''}`;

return api.get(url);
}
// Fetching Leave Page data
export const getLeave = (userId) => {
  return api.get(`leaves/${userId}`);
};

// Fetching Leave Page data
export const applyLeave = (userId, payload) => {
  return api.post(`applyLeave`, payload);
};

// Fetching Leave Page data
export const updateLeave = (payload) => {
  return api.put('update-leave', payload);
};

// Fetching Leave Page data
export const getCheckInStatus = () => {
  return api.get(`checkInStatus`);
};

// Fetching Approval Page data
export const getLeaveApprovals = ({ pageNumber, pageSize, userId, leaveStatus, startDate, endDate, leaveMasterId }) => {
  const queryParams = [
    userId && `userId=${userId}`,
    leaveStatus && `leaveStatus=${leaveStatus}`,
    startDate && `startDate=${startDate}`,
    endDate && `endDate=${endDate}`,
    leaveMasterId && `leaveMasterId=${leaveMasterId}`,
    pageNumber && `pageNumber=${pageNumber}`,
    pageSize && `pageSize=${pageSize}`
  ].filter(Boolean).join('&');
  return api.get(`allUserLeaves${queryParams ? `?${queryParams}` : ''}`);
};


// Fetching Leave Page data
export const userCheckedInOut = (payload) => {
  return api.post(`checkIn_checkout`, payload);
};

// Updating Leave data
export const approveOrRejectLeave = (userId, payload) => {
  return api.put('approveOrRejectLeave', { userId, ...payload });
};


// Updating Leave data
export const getTeamAndRm = (house) => {
  return api.get(`teamsAndRM?house=${encodeURIComponent(house)}`);
};

// Updating Leave data
export const attendanceDownload = ({ month, year, reportingManagerIdsArray, team, isDownloadReq, house }) => {
  const queryParams = [
    team && `team=${encodeURIComponent(team)}`,
    month && `month=${encodeURIComponent(month)}`,
    year && `year=${encodeURIComponent(year)}`,
    isDownloadReq && `isDownloadReq=${encodeURIComponent(isDownloadReq)}`,
    house && `house=${encodeURIComponent(house)}`,
    reportingManagerIdsArray && `reportingManagerIdsArray=${encodeURIComponent(JSON.stringify(reportingManagerIdsArray))}`
  ].filter(Boolean).join('&');

  return api.get(`attendance${queryParams ? `?${queryParams}` : ''}`);
};



